import { motion } from "framer-motion";
import { Target, Eye, CheckCircle2 } from "lucide-react";
import { IMAGES, CAPABILITIES } from "../../data/content";

export const About = () => {
  return (
    <section id="nosotros" data-testid="about-section" className="bg-[#0A0A0A] py-24 border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-body text-sm tracking-[0.25em] uppercase text-[#FF1616]">¿Quiénes Somos?</span>
            <h2 className="font-heading font-black uppercase text-white text-3xl sm:text-4xl tracking-tight mt-3">
              Mantenimiento minero de calidad
            </h2>
            <p className="font-body text-neutral-300 leading-relaxed mt-5">
              Somos una empresa dedicada al rubro de la minería, enfocada en la reparación, servicio técnico y venta de
              refacciones. Colaboramos siempre en equipo para resolver las necesidades de cada uno de nuestros clientes.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              <div className="bg-[#141414] border border-[#262626] p-6 hover:border-[#FF1616] transition-colors">
                <Target className="text-[#FF1616] mb-3" size={26} />
                <h3 className="font-heading font-bold uppercase text-white text-lg">Misión</h3>
                <p className="font-body text-sm text-neutral-400 mt-2 leading-relaxed">
                  Brindar un servicio oportuno y eficiente que permita a nuestros clientes cumplir con sus objetivos de
                  producción.
                </p>
              </div>
              <div className="bg-[#141414] border border-[#262626] p-6 hover:border-[#FF1616] transition-colors">
                <Eye className="text-[#FF1616] mb-3" size={26} />
                <h3 className="font-heading font-bold uppercase text-white text-lg">Visión</h3>
                <p className="font-body text-sm text-neutral-400 mt-2 leading-relaxed">
                  Ser una empresa líder y competitiva a nivel nacional, destacada por sus altos estándares y
                  responsabilidad.
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-x-6 gap-y-3 mt-8">
              {CAPABILITIES.map((c) => (
                <div key={c.label} className="flex items-center gap-2">
                  <CheckCircle2 className="text-[#FF1616]" size={18} />
                  <span className="font-body text-sm text-neutral-300">{c.label}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <img
              src={IMAGES.about}
              alt="Equipo minero en operación"
              className="w-full h-[480px] object-cover border border-[#262626]"
            />
            <div className="absolute -bottom-5 -left-5 bg-[#FF1616] text-black px-8 py-5 hidden sm:block">
              <div className="font-heading font-black text-3xl leading-none">+10</div>
              <div className="font-body text-xs uppercase tracking-wider mt-1">años en minería</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
